<template>
  <div class="wrapper">
    <div class="main-panel" v-if="loadPage">
      <dashboard-content></dashboard-content>
      <div class="inner-noti" v-if="!noBanner && banners && banners.length">
        <notification-banner
          :notification="banners[0]"
          afterLogin="true"
          @userStatus="userStatus"
        ></notification-banner>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import DashboardContent from './Content.vue';
import EventBus from '../../utils/event-bus';
import { getCookie } from '../../utils/common';
import NotificationBanner from '../SystemNotifications/NotificationBanner.vue';
import { getActiveBanner, getBannerStatus } from '../../apis/systemNotifications';
import { getUserData } from '../../apis/profile';

export default {
  data() {
    return {
      loadPage: false,
      banners: [],
      noBanner: false,
      loaderStatus: false,
    };
  },
  components: {
    Loader,
    DashboardContent,
    NotificationBanner,
  },
  beforeDestroy() {
    EventBus.$off();
    $('.modal-backdrop').remove();
  },
  methods: {
    userStatus(status) {
      this.noBanner = status;
    },
    async getUserData() {
      const userDataStorage = await getUserData();
      if (userDataStorage) {
        localStorage.setItem('userId', userDataStorage.id);
        localStorage.setItem('userData', JSON.stringify(userDataStorage));
      }
    },
  },
  async created() {
    this.loaderStatus = true;
    localStorage.removeItem('reLoad');
    if (!getCookie('Authorization')) {
      document.cookie = `redirect_url = ${window.location.href}; path=/;`;
      localStorage.clear();
      window.location.href = '/login';
      this.loadPage = false;
    } else {
      this.banners = await getActiveBanner();
      if (this.banners && this.banners.length) {
        if (!localStorage.getItem('userId')) await this.getUserData();
        this.noBanner = await getBannerStatus(
          JSON.parse(localStorage.getItem('userId')),
          this.banners[0].id
        );
      }
      this.loadPage = true;
      this.loaderStatus = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.inner-noti {
  position: fixed;
  bottom: 30px;
  z-index: 9;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
}
</style>
